module.exports = __webpack_public_path__ + "img/img12.03e296f8.png";